<template>
	<v-dialog  
	 	v-model="dialog"
		:fullscreen="fullscreen"
		transition="dialog-bottom-transition"
		scrollable
		:max-width="maxWidth"
		persistent
	>
	<!-- :max-width="fullscreen? null: maxWidth" -->

		<!-- Актіватор -->
		<template v-slot:activator="{ on: dialog, attrs }">
			<v-tooltip bottom>
				<template v-slot:activator="{ on: tooltip, attrs }">
					<slot name="activator" :attrs="attrs" :dialog="dialog" :tooltip="tooltip">
						<v-btn icon v-bind="attrs" v-on="{ ...tooltip, ...dialog }">
							<v-icon>{{ icon }}</v-icon>
						</v-btn>
					</slot>
				</template>
				<!-- <span>{{ $vuetify.lang.t(`$vuetify.${tooltip}`) | capitalize }}</span> -->
				<span>{{ tooltip }}</span>
			</v-tooltip>
		</template>

		<v-card>
			<!-- Ttoolbar -->
			<v-toolbar flat dark color="primary" style="flex: 0 1 auto;">
				<v-avatar>
					<v-icon>{{ icon }}</v-icon>
				</v-avatar>
				<v-toolbar-title>{{ title }}</v-toolbar-title>
				
				<v-spacer></v-spacer>

				<v-btn icon @click="fullscreen = !fullscreen">
					<v-icon v-if="fullscreen">mdi-arrow-collapse</v-icon>
					<v-icon v-else="fullscreen">mdi-arrow-expand</v-icon>
				</v-btn>
				<v-btn icon @click="dialog=false" >
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>

			<v-card-text class="pt-6">
				<v-form ref="form">
					<v-row>
						<v-col cols="12">
							<v-text-field
								:label="$vuetify.lang.t('$vuetify.name') | capitalize"
								v-model="item.name"
								clearable
								outlined
								dense
								hide-details="auto"
							></v-text-field>
						</v-col>
						<v-col cols="12" sm="6">
							<v-combobox
								v-model="item.year_start"
								:items="years"
								label="Рік випуску авто з"
								clearable
								outlined
								dense
								hide-details="auto"
							></v-combobox>
						</v-col>
						<v-col cols="12" sm="6">
							<v-combobox
								v-model="item.year_end"
								:items="years"
								label="Рік випуску авто по"
								clearable
								outlined
								dense
								hide-details="auto"
							></v-combobox>
						</v-col>
						<v-col cols="12" sm="6">
							<v-select
								v-model="item.currency"
								:items="currencies"
								label="Валюта"
								item-text="name"
								item-value="id"
								outlined
								dense
								hide-details="auto"
							>
								<template v-slot:item="{ on, item }">
									<v-list-item v-on="on">
										<v-list-item-content>
											<v-list-item-title>{{ item.name }}</v-list-item-title>
										</v-list-item-content>
									</v-list-item>
								</template>
							</v-select>
						</v-col>
						<!-- <v-col cols="12" sm="6">
							<z-date
								v-model="item.datebegin"
								label="Дата початку періоду"
								outlined
								dense
								hide-details="auto"
							></z-date>
						</v-col>
						<v-col cols="12" sm="6">
							<z-date
								v-model="item.dateend"
								label="Дата завершення періоду"
								outlined
								dense
								hide-details="auto"
							></z-date>
						</v-col> -->
						<!-- <v-col cols="12" sm="6">
							<v-menu
								v-model="menu.datebegin"
								:close-on-content-click="false"
								:nudge-right="40"
								transition="scale-transition"
								offset-y
								min-width="auto"
							>
								<template v-slot:activator="{ on, attrs }">
								<v-text-field v-bind="attrs" v-on="on"
									v-model="item.datebegin"
									label="Дата початку періоду"
									prepend-icon="mdi-calendar"
									readonly
									outlined
									dense
									hide-details="auto"
								></v-text-field>
								</template>
								<v-date-picker
									v-model="item.datebegin"
									@input="menu.datebegin = false"
								></v-date-picker>
							</v-menu>
						</v-col>
						<v-col cols="12" sm="6">
							<v-menu
								v-model="menu.dateend"
								:close-on-content-click="false"
								:nudge-right="40"
								transition="scale-transition"
								offset-y
								min-width="auto"
							>
								<template v-slot:activator="{ on, attrs }">
								<v-text-field v-bind="attrs" v-on="on"
									v-model="item.dateend"
									label="Дата завершення періоду"
									prepend-icon="mdi-calendar"
									readonly
									outlined
									dense
									hide-details="auto"
								></v-text-field>
								</template>
								<v-date-picker
									v-model="item.dateend"
									@input="menu.dateend = false"
								></v-date-picker>
							</v-menu>
						</v-col>
						<v-col cols="12" sm="6">
							<v-select
								v-model="item.type"
								:items="types"
								label="Тип"
								item-text="name"
								item-value="id"
								outlined
								dense
								hide-details="auto"
							>
								<template v-slot:item="{ on, item }">
									<v-list-item v-on="on">
										<v-list-item-content>
											<v-list-item-title>{{ item.name }}</v-list-item-title>
										</v-list-item-content>
									</v-list-item>
								</template>
							</v-select>
						</v-col>
						<v-col cols="12" sm="6">
							<v-select
								v-model="item.currency"
								:items="currencies"
								label="Валюта"
								item-text="name"
								item-value="id"
								outlined
								dense
								hide-details="auto"
							>
								<template v-slot:item="{ on, item }">
									<v-list-item v-on="on">
										<v-list-item-content>
											<v-list-item-title>{{ item.name }}</v-list-item-title>
										</v-list-item-content>
									</v-list-item>
								</template>
							</v-select>
						</v-col> -->
					</v-row>
				</v-form>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn text @click.native="onCancel">{{ $vuetify.lang.t('$vuetify.cancel') }}</v-btn>
				<v-btn color="success" dark @click.native="onOK" :disabled="loading">{{ $vuetify.lang.t('$vuetify.ok') }}</v-btn>
			</v-card-actions>
		</v-card>

		<v-overlay :value="loading">
			<v-progress-circular indeterminate size="64"></v-progress-circular>
		</v-overlay>
	</v-dialog>
</template>

<script>
import axios from 'axios'
import mixin from './mixin/main'
import { mapGetters, mapActions } from 'vuex'
import zDate from '@/views/components/control/Date'

export default {
	name: 'DialogDetailCatalogVehicleFile',
	mixins: [mixin],
	components: { zDate },
	data: () => ({
		item: {
			name: 'Каталог цін транспортних засобів ',
			year_start: 2015,
			year_end: 2015,
			//datebegin: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
			//dateend: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
			//type: 7,
			currency: 980,
		},

		menu: {
			datebegin: false,
			dateend: false,
		},
		loadings: {
			type: false,
			currency: false,
		},
	}),

	props: {
		title: 				{ type: String, default: 'Створення каталогу цін транспортних засобів' },
		icon: 				{ type: String, default: 'mdi-file-document-plus' },
		maxWidth: 			{ type: Number, default: 800 },

		category: 			{ type: Object, default: null },
		brand: 				{ type: Object, default: null },
		model: 				{ type: Object, default: null },
		modelYear: 			{ type: Number, default: null },
		type: 				{ type: Object, default: null },
	},

	computed: {
		...mapGetters('CatalogVehiclePriceType', { types: 'items' }),
		...mapGetters('CurrencyType', { currencies: 'items' }),

		years() {
			const today = new Date();
			const year = today.getFullYear();
			const arrayRange = (start, stop, step) =>
			Array.from(
				{ length: (stop - start) / step + 1 },
				(value, index) => start + index * step
			);

			return arrayRange(1990, year, 1).reverse();
		},
	},

	created () {
		const today = new Date();
		const year = today.getFullYear();
		let month = today.getMonth() + 1; // Month is 0-indexed, so add 1
		let day = today.getDate();

		if (month < 10) { month = '0' + month;}
		if (day < 10) { day = '0' + day; }

		this.item.name = `Каталог цін транспортних засобів ${year}${month}${day}`;
		this.item.year_end = year;


		const dateend = new Date();
		this.$set(this.item, 'dateend', dateend.toISOString().substring(0, 10));

        //const daysToSubtract = 30;

		const datebegin = new Date();
		datebegin.setDate(datebegin.getDate() - 30);
		//datebegin.setDate(datebegin.getMonth() - 1);

		//const dateend = today.toISOString().substring(0, 10);
		this.$set(this.item, 'datebegin', datebegin.toISOString().substring(0, 10));
		


       /*  today.setDate(today.getDate() - daysToSubtract);
        const initialDate = today.toISOString().substring(0, 10); */

		//console.log(this.$options.name, 'created')

		/* this.focusCategory()?.then(() => this.$set(this.item, 'category', this.categories[0]))
		this.focusType()?.then(() => this.$set(this.item, 'type', this.types[0])) */

		/* this.$set(this.item, 'datebegin', (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10))
		this.$set(this.item, 'dateend', (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)) */

		/* if(this.types.length == 0) {
			this.loadings.type = true
			this.loadType().then(() => this.$set(this.item, 'type', this.types[0])).finally(() => (this.loadings.type = false));
		}

		if(this.currencies.length == 0) {
			this.loadings.currency = true
			this.loadCurrency().then(() => this.$set(this.item, 'currency', this.currencies[2])).finally(() => (this.loadings.currency = false));
		} */
		if(this.types.length == 0) {
			this.loadType();
		}

		if(this.currencies.length == 0) {
			this.loadCurrency();
		}
	},

	methods: {
		...mapActions('CatalogVehiclePriceType', { loadType: 'load'}),
		...mapActions('CurrencyType', { loadCurrency: 'load'}),

		
		onOpen () {
			//console.log('details.mixin.main', 'onOpen', 'item', this.item)

			/* this.$set(this.item, 'type', 7)
			this.$set(this.item, 'currency', 980) */

			/* if(this.selected?.id) {
				this.find(this.selected.id)
			} else {
				if(this.category) this.$set(this.item, 'category', this.category)
				if(this.brand) this.$set(this.item, 'brand', this.brand)
				if(this.model) this.$set(this.item, 'model', this.model)
				if(this.modelYear) this.$set(this.item, 'modelYear', this.modelYear)
				if(this.type) this.$set(this.item, 'type', this.type)
			} */
		},

		onOK() {
			//console.log(this.$options.name, 'onOK','item', this.item)

			let that = this
			if(this.$refs.form.validate()) {
				this.loading = true
				axios.post('/catalog/vehicle/price/csv', null, { params: this.item }).then(response => {
					//console.log(that.$options.name, 'onOK','response.data', response.data)
					that.dialog = false
					this.$emit('ok', response.data);
				}, error => {
					console.log('error', error)
				}).finally(() => {
					this.loading = false
				});
			}
		},
	},
}
</script>